import { Icon, IconProps } from '@chakra-ui/react'

export const QuoteMarkIcon = (props: IconProps) => {
  return (
    <Icon
      viewBox='0 0 696 512'
      height='100px'
      width='100px'
      fill='#fff'
      {...props}>
      <g>
        <path d='m334.94 222.6c-0.22266-2.2969-0.67188-4.6484-1.2305-6.9453-4.9844-58.016-53.648-103.6-112.95-103.6-62.664 0-113.46 50.793-113.46 113.46 0 60.871 47.938 110.38 108.08 113.18-14.504 22.902-37.855 41.441-66.359 50.176l-0.95312 0.28125c-13.215 4.0312-22.344 16.91-21.113 31.246 1.3984 16.52 15.902 28.785 32.48 27.383 48.777-4.1445 97.551-29.062 130.7-69.551 16.633-20.16 29.512-43.902 37.352-69.777 7.8945-25.816 10.586-53.703 7.8945-81.199z' />
        <path d='m591.25 222.6c-0.22266-2.2969-0.67188-4.6484-1.2305-6.9453-4.9844-58.016-53.648-103.6-112.95-103.6-62.664 0-113.46 50.793-113.46 113.46 0 60.871 47.938 110.38 108.08 113.18-14.504 22.902-37.855 41.441-66.359 50.176l-0.95312 0.28125c-13.215 4.0312-22.344 16.91-21.113 31.246 1.3984 16.52 15.902 28.785 32.48 27.383 48.777-4.1445 97.551-29.062 130.7-69.551 16.633-20.16 29.512-43.902 37.352-69.777 7.8945-25.816 10.586-53.703 7.8945-81.199z' />
      </g>
    </Icon>
  )
}
